import { defineStore } from 'pinia';
import { ref } from 'vue';
import { GetClient } from '../services/Clients/GetClient';
import { ClientInterface } from '../types/clientInterface';


export const useClientStore = defineStore('client', () => {
  const client = ref<ClientInterface>({
    id: null,
    clientImageUrl: '',
    defaultClientImageUrl: '',
    parentBaseUrl: '',
  });

  const getClient = async () => {
    const response: ClientInterface = await GetClient();
    client.value = response;
  };

  return {
    client,
    getClient,
  };
});
